/**
 * Created by Jerker Nord on 2021-05-04.
 */
import {
    SimplePresentation,
    SimplePresentationRunnerController
} from "../../../core/winpresentation/SimplePresentationRunner";
import {TrueGrit} from "../../TrueGrit";
import {TrueGritGameMode} from "../../server/TrueGritGameMode";
import {gsap, TimelineMax} from "gsap";
import {TrueGritSymbol} from "../../reels/TrueGritSymbol";
import {TrueGritSound} from "../../sound/TrueGritSound";
import {BetWayWinData} from "../../server/TrueGritData";

export class TrueGritAvalancheWinRunner implements SimplePresentation {

    /**
     * Removes win symbols and trigger collapse reel animation on all reels
     */

    private _collapseCounter:number;

    public shouldRun(): boolean {
        return TrueGrit.model.gameData.nextMode == TrueGritGameMode.NORMAL_AVALANCHE;
    }

    public start(controller:SimplePresentationRunnerController): void {
        const mainTL:TimelineMax = gsap.timeline({onComplete : () => {
                // #133
                if (isStickyWildWinning) {
                    TrueGrit.symbolBoxView.scaleOutStickyWildMultiplierText();
                }
                this.collapseReels();
            }});
        const subRemoveSymbolsTLs:gsap.core.Timeline[] = [];
        const subWinShineTLs:gsap.core.Timeline[] = [];

        const topRightPosition:PIXI.Point = new PIXI.Point(0, 0),
            betWayWins: BetWayWinData[] = TrueGrit.model.gameData.betWayWins;
        let longestLine = 0,
            m0Hit:boolean = false,
            m0HitAmount: number = 0,
            m0HitTimesX: number = 0;
        for(let i:number = 0; i < betWayWins.length; i++) {
            m0Hit = betWayWins[i].symbol == "M0" ? true : m0Hit;
            longestLine = betWayWins[i].length > longestLine ? betWayWins[i].length : longestLine;

            if (m0HitAmount === 0 && m0Hit) {
                m0HitAmount = betWayWins[i].multipliedAmount;
                m0HitTimesX = (m0HitAmount / TrueGrit.model.gameData.playedBetValue);
            }
        }

        // #355
        if (m0Hit) {
            const symbols = TrueGrit.allReelsView.getAllVisibleSymbols();

            // #420
            mainTL.add(() => {
                let soundName: string;
                if (m0HitTimesX <= 100) {
                    soundName = TrueGritSound.GRIT_GIRL_SHAKE_1;
                } else if (m0HitTimesX <= 500) {
                    soundName = TrueGritSound.GRIT_GIRL_SHAKE_2;
                } else {
                    soundName = TrueGritSound.GRIT_GIRL_SHAKE_3;
                }

                TrueGrit.soundPlayer.playSound(soundName);
            });
            for (let symbol of symbols){
                mainTL.add((<TrueGritSymbol>symbol).getM0HitShakeAnimation(m0HitTimesX),0);
            }
        }

        let symCount = 0;
        for(let i:number = 0; i < TrueGrit.model.allWinPositions.length; i++) {
            for(let j:number = 0; j < TrueGrit.model.allWinPositions[i].length; j++) {
                if(TrueGrit.model.allWinPositions[i][j]) {
                    symCount++;

                    if(i > topRightPosition.x) {
                        topRightPosition.x = i;
                        topRightPosition.y = j;
                    }
                    const winShineTL:gsap.core.Timeline = gsap.timeline();
                    winShineTL.add(TrueGrit.initialWinBelowView.getWinShineAnimation(i, j), "+=");
                    subWinShineTLs.push(winShineTL);

                    const removeWinSymbolsTL:gsap.core.Timeline = gsap.timeline();
                    let symbol:TrueGritSymbol;
                    //This is a win on the top reel
                    if(j == 0 && (i > 0 || i < 4)) {
                        symbol = <TrueGritSymbol>TrueGrit.allReelsView.topReelModel.getSymbolBySymbolPosition(i);
                    } else if(j == 4 && i > 1 && i < 5) {
                        //This is a win on the bot reel
                        symbol = <TrueGritSymbol>TrueGrit.allReelsView.bottomReelModel.getSymbolBySymbolPosition(i - 1);
                    } else {
                        symbol = <TrueGritSymbol>TrueGrit.allReelsView.mainReelModels[i].getSymbol(j);
                    }

                    removeWinSymbolsTL.add(TrueGrit.initialWinTopView.getExplosionAnimation(i, j));
                    removeWinSymbolsTL.add(() => {
                        if(symbol) {
                            symbol.isRemoved = true;
                        }
                    });

                    //This is a win on the top reel
                    if(j == 0 && (i > 0 || i < 4)) {
                        removeWinSymbolsTL.add(() => TrueGrit.allReelsView.topReelModel.reelView.removeAvalancheSymbol(symbol), "-=0.6");
                    } else if(j == 4 && i > 1 && i < 5) {
                        //This is a win on the bot reel
                        removeWinSymbolsTL.add(() => TrueGrit.allReelsView.bottomReelModel.reelView.removeAvalancheSymbol(symbol), "-=0.6");
                    } else {
                        if(symbol) {
                            removeWinSymbolsTL.add(() => TrueGrit.allReelsView.mainReelModels[i].reelView.removeAvalancheSymbol(symbol), "-=0.6");
                        }
                    }

                    removeWinSymbolsTL.add(() => {TrueGrit.initialWinTopView.getSmokeAnimation(i, j)}, "-=0.7");
                    subRemoveSymbolsTLs.push(removeWinSymbolsTL);
                }
            }
        }

        const isStickyWildWinning: boolean = TrueGrit.model.allWinPositions[5][4];

        mainTL.add(()=>TrueGrit.soundPlayer.playInitialWinSound(symCount, longestLine, isStickyWildWinning, m0Hit));
        mainTL.add(subWinShineTLs);

        mainTL.add(() => {
            TrueGrit.symbolBoxView.setWildMultiplierText("x" + (TrueGrit.model.botTrain.wildMult + 1).toString(), isStickyWildWinning);
            TrueGrit.trueGritGritGirlSymbols.setMultiplierOnAllActiveSyms(TrueGrit.model.botTrain.wildMult + 1);
        }, "-=0.1");

        mainTL.add(subRemoveSymbolsTLs, ( "-=0.4")); // #133

        mainTL.add(() => controller.finish(), "-=0.4");

        mainTL.add(() => {TrueGrit.initialWinTopView.getRoundWinAnimation(betWayWins)}, "-=0.8");

        // #476
        if (m0Hit) {
            mainTL.add(TrueGrit.initialWinTopView.getM0RoundWinAnimation(m0HitAmount, m0HitTimesX), "-=0.8");
        }

        mainTL.add(() => TrueGrit.keypadPlugin.setWin(TrueGrit.model.data.accumulatedRoundWin, true, TrueGrit.isWinBelowStake()), "-=0.7");

        if(mainTL.duration() == 0) {
            mainTL.add(gsap.to(this, {duration : 0.001}));
        }
    }

    private collapseReels():void {
        this._collapseCounter = 0;
        const mainTL:TimelineMax = gsap.timeline();
        //Collapse main reels
        const subCollapseReelsTLs:gsap.core.Timeline[] = [];
        for(let i:number = 0; i < TrueGrit.model.allWinPositions.length; i++) {
            const collapseReelTL:gsap.core.Timeline = gsap.timeline({onComplete : () => this.collapseTLComplete()});
            collapseReelTL.add(TrueGrit.allReelsView.mainReelModels[i].collapseReel());
            subCollapseReelsTLs.push(collapseReelTL);
        }
        //Collapse top reel
        const collapseTopReelTL:gsap.core.Timeline = gsap.timeline({onComplete : () => this.collapseTLComplete()});
        collapseTopReelTL.add(TrueGrit.allReelsView.topReelModel.collapseReel());
        subCollapseReelsTLs.push(collapseTopReelTL);

        //Collapse bottom reel
        const collapseBottomReelTL:gsap.core.Timeline = gsap.timeline({onComplete : () => this.collapseTLComplete()});
        collapseBottomReelTL.add(TrueGrit.allReelsView.bottomReelModel.collapseReel());
        subCollapseReelsTLs.push(collapseBottomReelTL);

        mainTL.add(() => {subCollapseReelsTLs});

        if(mainTL.duration() == 0) {
            mainTL.add(gsap.to(this, {duration : 0.001}));
        }
    }

    private collapseTLComplete():void {
        this._collapseCounter++;
        if(this._collapseCounter == 8) {
            this.collapseReelsComplete();
        }
    }

    private collapseReelsComplete():void {
        TrueGrit.model.avalancheCollapseComplete = true;
        TrueGrit.avalancheFillUpReels.checkToStartFillUp();
    }
}